import React from 'react';

const allFeatures = [
  { title: 'Invoice templates', desc: 'Customizable templates adaptable for different industries.' },
  { title: 'Manage customers/products', desc: 'Maintain your catalog and client list as you create.' },
  { title: 'Payment tracking', desc: 'Mark payment status for easy tracking.' },
  { title: 'Multi-currency', desc: 'Customizable currency settings and taxes.' },
  { title: 'Reports & analytics', desc: 'Insights into invoicing and payment trends.' },
  { title: 'User roles', desc: 'Control access with appAdmin, admin, manager and user roles.' },
  { title: 'End-to-End Encryption', desc: 'All sensitive data is encrypted in transit and at rest using industry-standard TLS 1.2+ protocols.' },
  { title: 'Role-Based Access Control', desc: 'Granular permissions ensure employees only access the data they need for their role.' },
  { title: 'Automatic Backups', desc: 'Daily automated backups ensure your critical business data is never lost.' },
];

export default function Features() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f9fafb',
      padding: '48px 24px'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '48px', textAlign: 'center' }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: '700',
            color: '#1f2937',
            margin: '0 0 16px 0'
          }}>Product Features</h1>
          <p style={{
            fontSize: '16px',
            color: '#6b7280',
            margin: 0
          }}>Everything you need to manage your business invoicing and operations</p>
        </div>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '24px'
        }}>
          {allFeatures.map((f, i) => (
            <div key={i} style={{
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '24px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              e.currentTarget.style.transform = 'translateY(-4px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
              <h4 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#1f2937',
                margin: '0 0 12px 0'
              }}>{f.title}</h4>
              <p style={{
                fontSize: '14px',
                color: '#6b7280',
                margin: 0,
                lineHeight: '1.6'
              }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
